'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStarted = isStarted;

var _threadGetters = require('./threadGetters');

var _ChatFilterOptions = require('../../constants/ChatFilterOptions');

function isStarted(conversation) {
  return (0, _threadGetters.getStatus)(conversation) === _ChatFilterOptions.STARTED;
}